var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS5Kreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "s5kreis",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_533",
    "data-name": "Rechteck 533",
    width: 150,
    height: 150,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5143",
    "data-name": "Gruppe 5143",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_517",
    "data-name": "Ellipse 17",
    cx: 38.7,
    cy: 38.7,
    r: 38.7,
    transform: "translate(36.3 36.3)",
    fill: "#00537f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_543",
    "data-name": "Rechteck 43",
    width: 150,
    height: 150,
    transform: "translate(-1 3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5473",
    "data-name": "Pfad 5473",
    d: "M48.2,81.8H55c.6,4.1,2.6,5.6,7.6,5.6,3.5,0,6.5-1.2,6.5-4.4s-3.2-3.8-8.2-5C55,76.5,49.4,75.1,49.4,68c0-6.8,5.3-10,12.9-10s12.4,3.8,12.9,10.6H68.7c-.3-3.5-2.9-5-6.5-5S56,65.1,56,67.4c0,2.6,2.4,3.5,7.4,4.7C70.5,73.6,76,75.3,76,82.4,76,89.2,70.4,93,62.8,93,53.5,92.9,48.5,88.8,48.2,81.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5472",
    "data-name": "Pfad 472",
    d: "M75,41a32.688,32.688,0,0,1,32.8,32.576V73.8c0,17.6-15.2,34-32.8,34s-32.8-15.2-32.8-34h0A32.751,32.751,0,0,1,74.9,41H75m0-4.7A38.7,38.7,0,1,0,113.7,75h0A38.348,38.348,0,0,0,75.708,36.3Z",
    fill: "#00537f"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 102.49571,58.507836 H 83.594972 l -3.335424,18.707382 h 6.187454 c 1.353505,-1.88524 2.707011,-2.707012 5.172324,-2.707012 3.673802,0 5.849079,2.803691 5.849079,6.332473 0,3.383765 -2.271955,6.525832 -5.849079,6.525832 -3.045387,0 -5.220664,-2.030258 -5.559041,-5.075647 h -6.864207 c 0.14502,7.105905 5.994097,10.731367 12.568268,10.731367 6.767527,0.145018 12.568264,-5.220665 12.568264,-12.181552 0,-6.332473 -3.77048,-11.504797 -10.441327,-11.504797 -2.707012,0 -4.73727,0.725092 -6.62251,2.610332 l -0.09668,-0.09668 1.353505,-7.685978 h 13.970112 z",
    id: "path2648",
    style: {
      fill: "#ffffff",
      strokeWidth: "1.20849px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5Kreis);
export default __webpack_public_path__ + "static/media/s5kreis.324a1b685b1412c1856cdb1e5269202e.svg";
export { ForwardRef as ReactComponent };